import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'))
  ? 'http://localhost:8001/api' 
  : '/api';

const LoginDesignGallery = () => {
  const [selectedDesign, setSelectedDesign] = useState(null);
  const [saving, setSaving] = useState(false);

  // 50 farklı login tasarımı
  const designs = [
    { id: 1, name: "Professional Navy", preview: "linear-gradient(135deg, #1e293b 0%, #334155 100%)", desc: "Koyu navy arka plan, beyaz kart" },
    { id: 2, name: "Corporate Split", preview: "linear-gradient(90deg, #334155 0%, #334155 50%, #ffffff 50%, #ffffff 100%)", desc: "Sol koyu, sağ beyaz split" },
    { id: 3, name: "Clean White", preview: "linear-gradient(135deg, #f8fafc 0%, #ffffff 100%)", desc: "Beyaz minimal kart" },
    { id: 4, name: "Executive Dark", preview: "linear-gradient(135deg, #09090b 0%, #18181b 100%)", desc: "Siyah premium tema" },
    { id: 5, name: "Minimal Centered", preview: "linear-gradient(135deg, #ffffff 0%, #fafafa 100%)", desc: "En minimal beyaz" },
    
    { id: 6, name: "Kırmızı Gradient Geometrik", preview: "linear-gradient(180deg, #7a0d10 0%, #4a0508 45%, #200205 80%, #0a0203 100%)", desc: "Koyu kırmızı → siyah, blurlu üçgen + yarım daireler" },
    { id: 7, name: "Forest Green", preview: "linear-gradient(135deg, #059669 0%, #10b981 100%)", desc: "Yeşil orman teması" },
    { id: 8, name: "Sunset Orange", preview: "linear-gradient(135deg, #ea580c 0%, #f97316 100%)", desc: "Turuncu gün batımı" },
    { id: 9, name: "Royal Purple", preview: "linear-gradient(135deg, #7c3aed 0%, #a855f7 100%)", desc: "Kraliyet moru" },
    { id: 10, name: "Ruby Red", preview: "linear-gradient(135deg, #dc2626 0%, #ef4444 100%)", desc: "Kırmızı yakut" },
    
    { id: 11, name: "Midnight Blue", preview: "linear-gradient(135deg, #1e3a8a 0%, #1e40af 100%)", desc: "Gece mavisi" },
    { id: 12, name: "Charcoal Gray", preview: "linear-gradient(135deg, #374151 0%, #4b5563 100%)", desc: "Kömür grisi" },
    { id: 13, name: "Steel Blue", preview: "linear-gradient(135deg, #475569 0%, #64748b 100%)", desc: "Çelik mavisi" },
    { id: 14, name: "Slate Professional", preview: "linear-gradient(135deg, #64748b 0%, #94a3b8 100%)", desc: "Profesyonel slate" },
    { id: 15, name: "Graphite", preview: "linear-gradient(135deg, #27272a 0%, #3f3f46 100%)", desc: "Grafit koyu" },
    
    { id: 16, name: "Teal Corporate", preview: "linear-gradient(135deg, #0f766e 0%, #14b8a6 100%)", desc: "Kurumsal teal" },
    { id: 17, name: "Indigo Business", preview: "linear-gradient(135deg, #4338ca 0%, #6366f1 100%)", desc: "İş indigo" },
    { id: 18, name: "Emerald Pro", preview: "linear-gradient(135deg, #047857 0%, #059669 100%)", desc: "Profesyonel zümrüt" },
    { id: 19, name: "Amber Warm", preview: "linear-gradient(135deg, #d97706 0%, #f59e0b 100%)", desc: "Sıcak amber" },
    { id: 20, name: "Rose Elegant", preview: "linear-gradient(135deg, #e11d48 0%, #f43f5e 100%)", desc: "Zarif gül" },
    
    { id: 21, name: "Cyan Modern", preview: "linear-gradient(135deg, #0891b2 0%, #06b6d4 100%)", desc: "Modern cyan" },
    { id: 22, name: "Lime Fresh", preview: "linear-gradient(135deg, #65a30d 0%, #84cc16 100%)", desc: "Taze lime" },
    { id: 23, name: "Fuchsia Bold", preview: "linear-gradient(135deg, #c026d3 0%, #d946ef 100%)", desc: "Cesur fuşya" },
    { id: 24, name: "Sky Light", preview: "linear-gradient(135deg, #0284c7 0%, #0ea5e9 100%)", desc: "Açık gökyüzü" },
    { id: 25, name: "Violet Deep", preview: "linear-gradient(135deg, #6d28d9 0%, #7c3aed 100%)", desc: "Derin mor" },
    
    { id: 26, name: "Navy Classic", preview: "linear-gradient(135deg, #172554 0%, #1e3a8a 100%)", desc: "Klasik lacivert" },
    { id: 27, name: "Zinc Modern", preview: "linear-gradient(135deg, #3f3f46 0%, #52525b 100%)", desc: "Modern çinko" },
    { id: 28, name: "Stone Natural", preview: "linear-gradient(135deg, #57534e 0%, #78716c 100%)", desc: "Doğal taş" },
    { id: 29, name: "Neutral Gray", preview: "linear-gradient(135deg, #525252 0%, #737373 100%)", desc: "Nötr gri" },
    { id: 30, name: "Warm Gray", preview: "linear-gradient(135deg, #78716c 0%, #a8a29e 100%)", desc: "Sıcak gri" },
    
    { id: 31, name: "Cool Slate", preview: "linear-gradient(135deg, #334155 0%, #475569 100%)", desc: "Serin slate" },
    { id: 32, name: "Deep Ocean", preview: "linear-gradient(135deg, #075985 0%, #0c4a6e 100%)", desc: "Derin okyanus" },
    { id: 33, name: "Dark Forest", preview: "linear-gradient(135deg, #064e3b 0%, #065f46 100%)", desc: "Koyu orman" },
    { id: 34, name: "Wine Red", preview: "linear-gradient(135deg, #881337 0%, #9f1239 100%)", desc: "Şarap kırmızısı" },
    { id: 35, name: "Plum Purple", preview: "linear-gradient(135deg, #581c87 0%, #6b21a8 100%)", desc: "Erik moru" },
    
    { id: 36, name: "Sapphire Blue", preview: "linear-gradient(135deg, #1e40af 0%, #2563eb 100%)", desc: "Safir mavisi" },
    { id: 37, name: "Jade Green", preview: "linear-gradient(135deg, #166534 0%, #15803d 100%)", desc: "Yeşim yeşili" },
    { id: 38, name: "Copper Brown", preview: "linear-gradient(135deg, #92400e 0%, #b45309 100%)", desc: "Bakır kahverengi" },
    { id: 39, name: "Crimson Red", preview: "linear-gradient(135deg, #991b1b 0%, #b91c1c 100%)", desc: "Kızıl kırmızı" },
    { id: 40, name: "Orchid Pink", preview: "linear-gradient(135deg, #a21caf 0%, #c026d3 100%)", desc: "Orkide pembesi" },
    
    { id: 41, name: "Arctic Blue", preview: "linear-gradient(135deg, #164e63 0%, #155e75 100%)", desc: "Arktik mavisi" },
    { id: 42, name: "Moss Green", preview: "linear-gradient(135deg, #3f6212 0%, #4d7c0f 100%)", desc: "Yosun yeşili" },
    { id: 43, name: "Rust Orange", preview: "linear-gradient(135deg, #9a3412 0%, #c2410c 100%)", desc: "Pas turuncu" },
    { id: 44, name: "Berry Red", preview: "linear-gradient(135deg, #be123c 0%, #e11d48 100%)", desc: "Böğürtlen kırmızısı" },
    { id: 45, name: "Magenta Bold", preview: "linear-gradient(135deg, #9333ea 0%, #a855f7 100%)", desc: "Cesur macenta" },
    
    { id: 46, name: "Cobalt Blue", preview: "linear-gradient(135deg, #1d4ed8 0%, #2563eb 100%)", desc: "Kobalt mavisi" },
    { id: 47, name: "Pine Green", preview: "linear-gradient(135deg, #14532d 0%, #166534 100%)", desc: "Çam yeşili" },
    { id: 48, name: "Bronze Warm", preview: "linear-gradient(135deg, #78350f 0%, #92400e 100%)", desc: "Sıcak bronz" },
    { id: 49, name: "Maroon Deep", preview: "linear-gradient(135deg, #7f1d1d 0%, #991b1b 100%)", desc: "Derin bordo" },
    { id: 50, name: "Lavender Soft", preview: "linear-gradient(135deg, #7e22ce 0%, #9333ea 100%)", desc: "Yumuşak lavanta" }
  ];

  useEffect(() => {
    const fetchActiveDesign = async () => {
      try {
        const response = await axios.get(`${API}/public/active-login-design`);
        setSelectedDesign(response.data.design_id || 1);
      } catch (error) {
        console.error('Failed to fetch active design:', error);
        setSelectedDesign(1);
      }
    };
    fetchActiveDesign();
  }, []);

  const handleSelectDesign = async (designId) => {
    setSaving(true);
    try {
      await axios.post(
        `${API}/admin/set-login-design`,
        { design_id: designId },
        { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
      );
      setSelectedDesign(designId);
      alert(`✅ Tasarım #${designId} aktif edildi! Giriş sayfasını kontrol edin.`);
    } catch (error) {
      console.error('Failed to save design:', error);
      alert('❌ Tasarım kaydedilemedi!');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="p-4 sm:p-6">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-white mb-2">🎨 Giriş Ekranı Tasarımları</h2>
        <p className="text-gray-400">50 farklı profesyonel tasarımdan birini seçin - Tıklayarak aktif edin</p>
        {selectedDesign && (
          <div className="mt-3 inline-flex items-center gap-2 px-4 py-2 bg-blue-900 text-blue-200 rounded-lg">
            <span className="text-sm">Şu an aktif:</span>
            <strong>{designs.find(d => d.id === selectedDesign)?.name}</strong>
          </div>
        )}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {designs.map((design) => (
          <div
            key={design.id}
            className={`bg-gray-800 rounded-lg overflow-hidden transition-all cursor-pointer hover:scale-105 ${
              selectedDesign === design.id ? 'ring-4 ring-green-500 shadow-xl' : 'ring-1 ring-gray-700 hover:ring-2 hover:ring-gray-600'
            }`}
            onClick={() => handleSelectDesign(design.id)}
          >
            <div
              className="w-full h-32 relative"
              style={{ background: design.preview }}
            >
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="bg-white bg-opacity-90 rounded-lg px-4 py-2 text-center shadow-lg">
                  <div className="text-xl mb-1">🔐</div>
                  <div className="text-xs font-semibold text-gray-700">Giriş Yap</div>
                </div>
              </div>
              {selectedDesign === design.id && (
                <div className="absolute top-2 right-2 bg-green-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm">
                  ✓
                </div>
              )}
            </div>
            
            <div className="p-3">
              <div className="flex items-center justify-between mb-1">
                <span className="text-xs font-semibold text-gray-400">#{design.id}</span>
                {selectedDesign === design.id && (
                  <span className="text-xs bg-green-500 text-white px-2 py-0.5 rounded-full">AKTİF</span>
                )}
              </div>
              <h3 className="text-sm font-bold text-white mb-1">{design.name}</h3>
              <p className="text-xs text-gray-400">{design.desc}</p>
            </div>
          </div>
        ))}
      </div>

      {saving && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-gray-800 p-6 rounded-lg shadow-xl">
            <div className="text-white text-center">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white mx-auto mb-4"></div>
              <p>Tasarım aktif ediliyor...</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LoginDesignGallery;
